// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/assets/fonts/Inter/Inter-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/assets/fonts/Inter/Inter-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/assets/fonts/Inter/Inter-ThinItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/assets/fonts/Inter/Inter-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/assets/fonts/Inter/Inter-ExtraLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/assets/fonts/Inter/Inter-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/assets/fonts/Inter/Inter-ExtraLightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/assets/fonts/Inter/Inter-ExtraLightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/assets/fonts/Inter/Inter-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/assets/fonts/Inter/Inter-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/assets/fonts/Inter/Inter-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("/assets/fonts/Inter/Inter-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("/assets/fonts/Inter/Inter-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("/assets/fonts/Inter/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("/assets/fonts/Inter/Inter-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("/assets/fonts/Inter/Inter-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("/assets/fonts/Inter/Inter-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("/assets/fonts/Inter/Inter-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("/assets/fonts/Inter/Inter-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("/assets/fonts/Inter/Inter-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("/assets/fonts/Inter/Inter-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("/assets/fonts/Inter/Inter-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("/assets/fonts/Inter/Inter-SemiBoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("/assets/fonts/Inter/Inter-SemiBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("/assets/fonts/Inter/Inter-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("/assets/fonts/Inter/Inter-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("/assets/fonts/Inter/Inter-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("/assets/fonts/Inter/Inter-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("/assets/fonts/Inter/Inter-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("/assets/fonts/Inter/Inter-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("/assets/fonts/Inter/Inter-ExtraBoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("/assets/fonts/Inter/Inter-ExtraBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("/assets/fonts/Inter/Inter-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("/assets/fonts/Inter/Inter-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("/assets/fonts/Inter/Inter-BlackItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("/assets/fonts/Inter/Inter-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variable fonts usage:
:root { font-family: 'Inter', sans-serif; }
@supports (font-variation-settings: normal) {
  :root { font-family: 'InterVariable', sans-serif; font-optical-sizing: auto; }
} */

/* static fonts */
@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src:
    local("Inter Thin"),
    local("Inter-Thin"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 100;
  font-display: swap;
  src:
    local("Inter Thin Italic"),
    local("Inter-ThinItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 200;
  font-display: swap;
  src:
    local("Inter Extral Light"),
    local("Inter-ExtraLight"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 200;
  font-display: swap;
  src:
    local("Inter Extral Light Italic"),
    local("Inter-ExtraLightItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src:
    local("Inter Light"),
    local("Inter-Light"),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 300;
  font-display: swap;
  src:
    local("Inter Light Italic"),
    local("Inter-LightItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src:
    local("Inter Regular"),
    local("Inter-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src:
    local("Inter Italic"),
    local("Inter-Italic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src:
    local("Inter Medium"),
    local("Inter Medium"),
    url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 500;
  font-display: swap;
  src:
    local("Inter Medium Italic"),
    local("Inter-MediumItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src:
    local("Inter Semi Bold"),
    local("Inter-SemiBold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 600;
  font-display: swap;
  src:
    local("Inter Semi Bold Italic"),
    local("Inter-SemiBoldItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src:
    local("Inter Bold"),
    local("Inter-Bold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src:
    local("Inter Bold Italic"),
    local("Inter-BoldItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src:
    local("Inter Extra Bold"),
    local("Inter-ExtraBold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 800;
  font-display: swap;
  src:
    local("Inter Extra Bold Italic"),
    local("Inter-ExtraBoldItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src:
    local("Inter Black"),
    local("Inter-Black"),
    url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("truetype");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 900;
  font-display: swap;
  src:
    local("Inter Black Italic"),
    local("Inter-BlackItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("truetype");
}
`, "",{"version":3,"sources":["webpack://./src/app/styles/fonts.css"],"names":[],"mappings":"AAAA;;;;GAIG;;AAEH,iBAAiB;AACjB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;8DAI8D;AAChE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;8DAIoE;AACtE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;8DAIoE;AACtE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;8DAI0E;AAC5E;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;8DAI+D;AACjE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;+DAIqE;AACvE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;+DAIiE;AACnE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;+DAIgE;AAClE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;+DAIgE;AAClE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;+DAIsE;AACxE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;+DAIkE;AACpE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;+DAIwE;AAC1E;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;+DAI8D;AAChE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;+DAIoE;AACtE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;+DAImE;AACrE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;+DAIyE;AAC3E;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;+DAI+D;AACjE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;+DAIqE;AACvE","sourcesContent":["/* Variable fonts usage:\n:root { font-family: 'Inter', sans-serif; }\n@supports (font-variation-settings: normal) {\n  :root { font-family: 'InterVariable', sans-serif; font-optical-sizing: auto; }\n} */\n\n/* static fonts */\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 100;\n  font-display: swap;\n  src:\n    local(\"Inter Thin\"),\n    local(\"Inter-Thin\"),\n    url(\"/assets/fonts/Inter/Inter-Thin.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-Thin.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 100;\n  font-display: swap;\n  src:\n    local(\"Inter Thin Italic\"),\n    local(\"Inter-ThinItalic\"),\n    url(\"/assets/fonts/Inter/Inter-ThinItalic.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-ThinItalic.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 200;\n  font-display: swap;\n  src:\n    local(\"Inter Extral Light\"),\n    local(\"Inter-ExtraLight\"),\n    url(\"/assets/fonts/Inter/Inter-ExtraLight.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-ExtraLight.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 200;\n  font-display: swap;\n  src:\n    local(\"Inter Extral Light Italic\"),\n    local(\"Inter-ExtraLightItalic\"),\n    url(\"/assets/fonts/Inter/Inter-ExtraLightItalic.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-ExtraLightItalic.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src:\n    local(\"Inter Light\"),\n    local(\"Inter-Light\"),\n    url(\"/assets/fonts/Inter/Inter-Light.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-Light.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 300;\n  font-display: swap;\n  src:\n    local(\"Inter Light Italic\"),\n    local(\"Inter-LightItalic\"),\n    url(\"/assets/fonts/Inter/Inter-LightItalic.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-LightItalic.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src:\n    local(\"Inter Regular\"),\n    local(\"Inter-Regular\"),\n    url(\"/assets/fonts/Inter/Inter-Regular.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 400;\n  font-display: swap;\n  src:\n    local(\"Inter Italic\"),\n    local(\"Inter-Italic\"),\n    url(\"/assets/fonts/Inter/Inter-Italic.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-Italic.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src:\n    local(\"Inter Medium\"),\n    local(\"Inter Medium\"),\n    url(\"/assets/fonts/Inter/Inter-Medium.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-Medium.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 500;\n  font-display: swap;\n  src:\n    local(\"Inter Medium Italic\"),\n    local(\"Inter-MediumItalic\"),\n    url(\"/assets/fonts/Inter/Inter-MediumItalic.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-MediumItalic.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src:\n    local(\"Inter Semi Bold\"),\n    local(\"Inter-SemiBold\"),\n    url(\"/assets/fonts/Inter/Inter-SemiBold.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-SemiBold.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 600;\n  font-display: swap;\n  src:\n    local(\"Inter Semi Bold Italic\"),\n    local(\"Inter-SemiBoldItalic\"),\n    url(\"/assets/fonts/Inter/Inter-SemiBoldItalic.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-SemiBoldItalic.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src:\n    local(\"Inter Bold\"),\n    local(\"Inter-Bold\"),\n    url(\"/assets/fonts/Inter/Inter-Bold.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-Bold.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 700;\n  font-display: swap;\n  src:\n    local(\"Inter Bold Italic\"),\n    local(\"Inter-BoldItalic\"),\n    url(\"/assets/fonts/Inter/Inter-BoldItalic.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-BoldItalic.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 800;\n  font-display: swap;\n  src:\n    local(\"Inter Extra Bold\"),\n    local(\"Inter-ExtraBold\"),\n    url(\"/assets/fonts/Inter/Inter-ExtraBold.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-ExtraBold.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 800;\n  font-display: swap;\n  src:\n    local(\"Inter Extra Bold Italic\"),\n    local(\"Inter-ExtraBoldItalic\"),\n    url(\"/assets/fonts/Inter/Inter-ExtraBoldItalic.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-ExtraBoldItalic.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 900;\n  font-display: swap;\n  src:\n    local(\"Inter Black\"),\n    local(\"Inter-Black\"),\n    url(\"/assets/fonts/Inter/Inter-Black.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-Black.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 900;\n  font-display: swap;\n  src:\n    local(\"Inter Black Italic\"),\n    local(\"Inter-BlackItalic\"),\n    url(\"/assets/fonts/Inter/Inter-BlackItalic.woff2\") format(\"woff2\"),\n    url(\"/assets/fonts/Inter/Inter-BlackItalic.ttf\") format(\"truetype\");\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
